import api from 'utils/api'
import { getSession, isCurrentSession } from 'utils/session'
import * as types from './actionTypes.js'

export const fetchBusiness = (businessId, silent = false) => (dispatch) => {
  const context = getSession()
  if (!silent) {
    dispatch(fetchBusinessInit(businessId))
  }
  api
    .get(`/business/${businessId}`)
    .then((res) => {
      if (isCurrentSession(context)) dispatch(fetchBusinessSuccess(res, businessId))
    })
    .catch(error => {
      if (isCurrentSession(context) && !error.sessionHandled && !silent) dispatch(fetchBusinessFail(businessId))
    })
}

const fetchBusinessInit = (businessId) => ({
  type: types.FETCH_BUSINESS_INIT,
  businessId,
})

const fetchBusinessSuccess = (data, businessId) => ({
  type: types.FETCH_BUSINESS_SUCCESS,
  data,
  businessId,
})

const fetchBusinessFail = (businessId) => ({
  type: types.FETCH_BUSINESS_FAIL,
  businessId,
})

export const updateBusinessCompanyInfo = (companyInfoData) => ({
  type: types.UPDATE_BUSINESS_COMPANY_INFO,
  companyInfo: companyInfoData,
})

export const updateBusinessName = (businessId, name) => ({
  type: types.UPDATE_BUSINESS_NAME,
  businessId,
  name,
})

export const updateAccountName = (organizationId, name) => ({
  type: types.UPDATE_ACCOUNT_NAME,
  organizationId,
  name,
})

export const cleanupBusiness = (businesses) => ({
  type: types.CLEANUP_BUSINESS,
  data: businesses,
})

export const updateBusinessKeywords = keywords => ({
  type: types.UPDATE_BUSINESS_KEYWORDS,
  keywords,
})

export const updateBusinessBudget = budget => ({
  type: types.UPDATE_BUSINESS_BUDGET,
  budget,
})
